export default {
  methods: {
    remainingMinutes (recording) {
      if (!recording) return 0
      const durationMs = recording.duration || 0
      const lastPositionMs = recording.lastPositionMs || 0
      return Math.max(0, Math.round((durationMs - lastPositionMs) / 60000))
    },
    launchRecordingUrl (url, target, recording) {
      if (recording && recording.targetSystem === 'COLLABSECONDARY') {
        this.$emit('play-recording', {
          url,
          title: recording.name,
          captionsUrl: recording.captionsUrl,
          chat: recording.chat,
          recording
        })
      } else {
        window.open(url, target)
      }
    },
    getDownloadLinkClick (recording) {
      const target = recording.targetSystem === 'CONNECT' ? '_blank' : '_self'
      window.axios.get('recordings/' + recording.id + '/url/', {
        params: { targetSystem: recording.targetSystem, acInstanceId: recording.acInstance, disposition: 'download' }
      }).then((response) => {
        this.launchRecordingUrl(response.data.url, target)
      })
    },
    launchClickUrl (target, recording) {
      const validMinutes = 5
      if (!recording.loadingLaunchUrl && !recording.launchUrl) {
        this.$set(recording, 'loadingLaunchUrl', true)
        window.axios.get('recordings/' + recording.id + '/url/', {
          params: { targetSystem: recording.targetSystem, acInstanceId: recording.acInstance, validMinutes }
        }).then((response) => {
          this.$set(recording, 'loadingLaunchUrl', false)
          this.$set(recording, 'launchUrl', response.data.url)
          setTimeout(() => { this.$set(recording, 'launchUrl', '') }, validMinutes * 60000)
          this.launchRecordingUrl(recording.launchUrl, target, recording)
        })
      } else {
        this.launchRecordingUrl(recording.launchUrl, target, recording)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/recordingPlaybackMixin.js